/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useState, useEffect, useLayoutEffect, useMemo } from "react";
import NftPreview from "./NftPreview";
import MintFooter from "./MintFooter";
import Catalogue from "./Catalogue";
import Name from "./Name";
import Distribution from "./Distribution";
import PieDist from "./PieDist";
import FinalCheck from "./FinalCheck";
import { fundRaisin } from "../../contracts/fundraisin";
import Spinner from "../Spinner";
import { useNavigate, useOutletContext } from "react-router-dom";
import error from "../../config/error.json";
import { logError, logInfo } from "../../utils/log";
import Modal from "../Modal/Modal";
import Popup from "../Modal/Popup";
import Error from "../Modal/Error";
import Warning from "../Modal/Warning";
import {
  getBackgrounds,
  getPatterns,
  getLayers,
  getLayerChoices,
  getApprovedNames,
  getPresetDistribution,
  getRarityList,
  isApproved,
} from "../../utils/services";
import constant from "../../utils/constant";
import { v4 as uuidv4 } from "uuid";

const Mint = () => {
  const [
    siteDetails,
    walletAddress,
    connectWallet,
    isWalletConnected,
    ,
    ,
    ,
    ,
    ,
    ,
    forceUpdate,
  ] = useOutletContext();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState([]);
  const [patterns, setPatterns] = useState([]);
  const [layers, setLayers] = useState([]);
  const [layerChoice, setLayerChoice] = useState([]);
  const [sliders, setDefaultSlider] = useState([]);
  const [presetDistribution, setPresetDistribution] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [pieData, setPieData] = useState([]);
  const [preset, setPreset] = useState("");
  const [showPreset, setShowPreset] = useState(true);
  const [names, setNames] = useState([]);
  const [customDist, setCustomDist] = useState(false);
  const [data, setData] = useState([]);
  const [identifier, setIdentifier] = useState("");
  const [title, setTitle] = useState("");
  const [stepState, setStep] = useState(0);
  const [previewLink, setPreviewLink] = useState("");
  const [errShow, setErrShow] = useState(false);
  const [warnShow, setWarnShow] = useState(false);
  const [errMessage, setErrorMessage] = useState();
  const [rarityList, setRarityList] = useState();
  const [rarityData, setRarityData] = useState({
    background: {},
    pattern: {},
    layer: {},
    layerchoice: {},
    layerclass: {},
    layerstylecolor: {},
    name: {},
  });

  const checkSiteActive = async () => {
    let siteActive = await isApproved();
    if (!siteActive[0]) {
      let errorMsg = "";
      const { startsOn } = siteDetails;
      if (Math.floor(Date.now() / 1000) >= startsOn) {
        errorMsg = error[siteActive[1]];
      } else {
        errorMsg = `Site will be actived from ${new Date(startsOn * 1000)}`;
      }
      openErrorModal(errorMsg);
    }
  };

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    checkSiteActive();
  }, []);

  useEffect(() => {
    artOptions[stepState].getData();
    setTitle(artOptions[stepState].title);
    setIdentifier(artOptions[stepState].identifier);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepState]);

  useEffect(() => {
    const previewData = async () => {
      if (artOptions[stepState].preview) await preview();
    };
    if (Object.keys(selectedItems).length > 0) previewData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(selectedItems)]);

  useMemo(() => {
    const getRarity = async () => {
      logInfo("get rarity info");
      let rarity = await getRarityList(siteDetails.siteId);
      setRarityList(rarity);
    };
    getRarity();
  }, []);

  useMemo(() => {
    const getPresetDistributions = async () => {
      if (Object.keys(siteDetails).length > 0 && sliders.length === 0) {
        setDefaultSlider(siteDetails.sliders);
        const presetExists = await getPresetDistribution();
        if (!presetExists.length) {
          setShowPreset(false)
        }
        setPresetDistribution(presetExists);
        
      }
      setLoading(false);
    };
    getPresetDistributions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteDetails.sliders, sliders.length]);

  useEffect(() => {
    if (!customDist) {
      changePreset(0);
    }
    setShowPreset(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customDist]);

  const changePreset = (id) => {
    const distribution = presetDistribution;
    if (distribution.length) {
      let pd = [];
      //Please dont change the order this will impact
      pd[0] = distribution[id].beneficiaryDistro / 100;
      pd[1] = distribution[id].artistDistro / 100;
      pd[2] = distribution[id].fundraiserDistro / 100;
      pd[3] = 100 - (pd[0] + pd[1] + pd[2]);
      setPieData([...pd]);
      setPreset(distribution[id].shortPresetName);
      setUserSelection({
        distribution: {
          presetName: distribution[id].shortPresetName,
          beneficiaryDistro: pd[0] * 100,
          artistDistro: pd[1] * 100,
          fundraiserDistro: pd[2] * 100,
          sellerDistro: pd[3] * 100,
        },
      });
      let setSliderDefaultToPreset = sliders.map((sl, i) => {
        sl.defaultValue = pd[i]; // > sl.min ? pd[i] : sl.min;
        return sl;
      });
      setDefaultSlider(setSliderDefaultToPreset);
    }
  };

  const artOptions = [
    {
      title: constant.BACKGROUND_COLOR,
      identifier: "background",
      widget: "catalogue",
      preview: true,
      navButton: constant.BACKGROUND_COLOR,
      getData: async function () {
        try {
          if (backgroundColor.length === 0) {
            let bg = await getBackgrounds(siteDetails.artCreationPackId);
            setBackgroundColor(bg);
            setData([...bg]);
          } else {
            setData([...backgroundColor]);
          }
          setLoading(false);
        } catch (err) {
          logError(err);
          setLoading(false);
        }
      },
    },
    {
      title: constant.PATTERN,
      identifier: "pattern",
      widget: "catalogue",
      preview: true,
      navButton: constant.PATTERN,
      getData: async function () {
        if (patterns.length === 0) {
          let pattern = await getPatterns(siteDetails.artCreationPackId);
          setPatterns(pattern);
          setData([...pattern]);
        } else {
          setData([...patterns]);
        }
        setLoading(false);
      },
    },
    {
      title: constant.PATTERN_COLOR,
      identifier: "layerchoice",
      widget: "catalogue",
      preview: true,
      navButton: constant.PATTERN_COLOR,
      getData: async function () {
        if (
          layers.length === 0 ||
          (layers && layers[0].patternId !== selectedItems.pattern.patternId)
        ) {
          let layer = await getLayers(
            siteDetails.artCreationPackId,
            selectedItems.pattern.patternId
          );

          let layerCh = await getLayerChoices(
            siteDetails.artCreationPackId,
            selectedItems.pattern.patternId,
            layer[0].layerId
          );
          setLayers(layer);
          setLayerChoice(layerCh);
          if (layerCh[0]) setUserSelection({ layerchoice: layerCh[0] });
          setData([...layerCh]);
        } else {
          setData([...layerChoice]);
        }
        setLoading(false);
      },
    },
    {
      title: constant.NAME,
      identifier: "name",
      widget: "name",
      preview: false,
      navButton: constant.NAME,
      getData: async function () {
        if (names.length === 0) {
          const names = await getApprovedNames(siteDetails.artCreationPackId);
          setNames(names);
        }
        setLoading(false);
      },
    },
    {
      title: constant.PICK_DISTRO,
      identifier: "distribution",
      widget: "distribution",
      preview: false,
      navButton: constant.ALTER_EGO,
      getData: async function () {
        if (sliders.length === 0) {
          setDefaultSlider(siteDetails.sliders);
          setPresetDistribution(await getPresetDistribution());
        }
        setLoading(false);
      },
    },
    {
      title: constant.FINAL_TEXT,
      identifier: "confirmation",
      navButton: constant.FINAL_CHECK,
      widget: "final",
      preview: false,
      getData: function () {
        setLoading(false);
      },
    },
  ];

  const openErrorModal = (err) => {
    setErrorMessage(err);
    setErrShow(!errShow);
  };

  const closeErrorModal = () => {
    setErrShow(!errShow);
  };

  const openWarnModal = () => {
    setWarnShow(!warnShow);
  };

  const closeWarnModal = () => {
    setWarnShow(!warnShow);
  };

  const prevStep = () => {
    if (stepState !== 0) {
      setData([]);
      setLoading(true);
      setStep(stepState - 1);
    }
  };

  const nextStep = () => {
    let errorMsg = "";
    if (validateSelection()) {
      if (stepState < artOptions.length - 1) {
        setData([]);
        setLoading(true);
        if (stepState === 3) {
          changePreset(0);
        }
        setStep(stepState + 1);
        window.scrollTo(0, 0);
      }
    } else {
      errorMsg = error.MINT_MANDATORY_OPTION_SELECT;
      openErrorModal(errorMsg);
    }
  };

  const validateSelection = () => {
    if (
      (stepState === 0 && selectedItems.background) ||
      (stepState === 1 && selectedItems.pattern) ||
      (stepState === 2 && selectedItems.layerchoice) ||
      (stepState === 3 && selectedItems.name) ||
      (stepState === 4 && selectedItems.distribution)
    ) {
      return true;
    }
    return false;
  };

  const preview = () => {
    let data = getPreviewData();
    setLoader(true);
    fetch(`/preview`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({ data, file: uuidv4() }),
    })
      .then(function (a) {
        return a.text(); // call the json method on the response to get JSON
      })
      .then(function (data) {
        setLoader(false);
        setPreviewLink(data);
      });
  };

  const mint = async (e) => {
    setWarnShow(!warnShow);
    let status = isWalletConnected;
    if (!isWalletConnected) {
      status = await connectWallet();
    }
    if (status) {
      setLoading(true);
      const _metadata = constructMintData();
      e.target.disabled = true;
      fetch(`/upload`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(_metadata),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            setLoading(false);
            e.target.disabled = false;
            alert("interenal server error");
          }
        })
        .then(function (res) {
          let mintRequest = constructMintRequestData(
            _metadata.nftMetadata,
            res
          );
          logInfo(mintRequest);
          mintToken(mintRequest, selectedItems.background.price.toString());
          e.target.disabled = false;
        });
    } else {
      setLoading(false);
    }
  };

  const constructMintRequestData = (metadata, res) => {
    return {
      siteId: siteDetails.siteId,
      name: {
        id: selectedItems.name.approvedNameId,
        name: `${selectedItems.name.approvedName} #${selectedItems.name.nextNameNumber}`,
        number: selectedItems.name.nextNameNumber,
      },
      description: metadata.description,
      presetDistribution: metadata.presetDistribution,
      attributes: metadata.attributes,
      distribution: [
        {
          value: selectedItems.distribution.fundraiserDistro,
          distCategory: "fundraiser",
        },
        {
          value: selectedItems.distribution.beneficiaryDistro,
          distCategory: "beneficiary",
        },
        {
          value: selectedItems.distribution.artistDistro,
          distCategory: "artist",
        },
      ],
      tokenUri: res.tokenUri,
    };
  };

  const constructMintData = () => {
    let nftMetadata = {};
    let attributes = [];
    nftMetadata.name = `${selectedItems.name.approvedName} #${selectedItems.name.nextNameNumber}`;
    nftMetadata.description = process.env.REACT_APP_WEBSITE_DESCRIPTION;
    nftMetadata.presetDistribution = selectedItems.distribution;
    nftMetadata.price = selectedItems.background.price.toString();
    nftMetadata.mintedAt = Number((new Date().getTime() / 1000).toFixed(0));
    nftMetadata.mintedBy = walletAddress;
    attributes.push({
      trait_type: "background",
      value: selectedItems.background.colorHexCode,
      id: selectedItems.background.backgroundId,
    });
    attributes.push({
      trait_type: "pattern",
      value: selectedItems.pattern.patternName,
      id: selectedItems.pattern.patternId,
    });
    attributes.push({
      trait_type: "layerchoice",
      value: selectedItems.layerchoice.layerURL,
      id: selectedItems.layerchoice.layerChoiceId,
    });
    attributes.push({
      trait_type: "approvedname",
      value: nftMetadata.name,
      id: selectedItems.name.approvedNameId,
    });
    attributes.push({
      trait_type: "distribution",
      value: selectedItems.distribution.presetName,
      id: 0,
    });
    nftMetadata.attributes = attributes;
    return { finalNFTimage: previewLink, nftMetadata };
  };


  const mintToken = async (mintRequest, price) => {
    await fundRaisin
      .mint(mintRequest, price)
      .then((message) => {
        forceUpdate();
        logInfo(message);
        if (message === false) {
          setTimeout(() => {
            setLoading(false);
            setStep(0);
            //setSelectedItems({});
            navigate("/my");
          }, 5000);
        } else if (message.status > 0) {
          setLoading(false);
          setStep(0);
          navigate("/my");
        } else {
          openErrorModal(error.UNKNOWN_ERROR);
        }
      })
      .catch((err) => {
        logError(err);
        let errorMsg = "";
        if (err) {
          setLoading(false);
          if (err.error) {
            err.data = err.error;
          }
          if (err.data && err.data.message) {
            let customMessage = err.data.message.split(":");
            if (
              customMessage.length > 1 &&
              error[customMessage[1].trim()] !== undefined
            ) {
              errorMsg = `${error[customMessage[1].trim()]
                .replace("%1", "Octopus")
                .replace("%2", "mint")
                .replace("%3", mintRequest.name.name)}`;
              if (customMessage[1].trim() === "ANE") setNames([]);
            } else {
              if ([32000].includes(Math.abs(err.data.code))) {
                errorMsg = error[Math.abs(err.code)]
                  .replace("%1", "Octopus")
                  .replace("%2", "mint")
                  .replace("%3", mintRequest.name.name);
              } else {
                errorMsg = err.data.message;
              }
            }
          } else if ([4001, 4100].includes(err.code)) {
            errorMsg = error[Math.abs(err.code)]
              .replace("%1", "Octopus")
              .replace("%2", "mint")
              .replace("%3", mintRequest.name.name);
          } else {
            errorMsg = error.UNKNOWN_ERROR;
          }
          openErrorModal(errorMsg);
        }
      });
  };

  const setUserSelection = async (selected) => {
    let _update = Object.assign(selectedItems, selected);
    setSelectedItems({ ..._update });
    logInfo(_update);
  };

  const getPreviewData = () => {
    let data = [];
    if (selectedItems.background) {
      data.push({
        value: selectedItems.background.colorHexCode,
        type: "color",
        class: "background",
      });
    }
    if (selectedItems.pattern) {
      data.push({
        value: selectedItems.pattern.thumbnailURL,
        type: "layer",
        class: "patterns",
        name: `pattern${selectedItems.pattern.patternId}`,
      });
    }
    if (selectedItems.layerchoice) {
      data.push({
        value: selectedItems.layerchoice.layerURL,
        type: "layer",
        class: "patterns",
        name: `layer${selectedItems.layerchoice.layerChoiceId}`,
      });
    }
    return data;
  };

  const renderWarnPopup = () => {
    let sellerDistribution = 100;
    if (selectedItems.distribution !== undefined) {
      let dist = selectedItems.distribution;
      sellerDistribution -=
        (dist.fundraiserDistro + dist.beneficiaryDistro + dist.artistDistro) /
        100;
    }
    return (
      <Modal show={warnShow} type={"warn"}>
        <Popup type={"warn"}>
          <Warning
            confirmAction={mint}
            onClose={closeWarnModal}
            sellerDistribution={sellerDistribution}
          />
        </Popup>
      </Modal>
    );
  };

  const renderErrorPopup = () => {
    return (
      <Modal show={errShow}>
        <Popup>
          <Error err={errMessage} onClose={closeErrorModal} />
        </Popup>
      </Modal>
    );
  };

  const renderStep = () => {
    if (artOptions[stepState].widget === "catalogue") {
      return (
        <Catalogue
          category={identifier}
          data={data}
          setUserSelection={setUserSelection}
          selectedItems={selectedItems}
          title={title}
          rarityList={rarityList}
          rarityData={rarityData}
          setRarityData={setRarityData}
        />
      );
    } else if (artOptions[stepState].widget === "name") {
      return (
        <Name
          nameList={names}
          setUserSelection={setUserSelection}
          selectedItems={selectedItems}
          title={title}
          customDist={customDist}
          setCustomDist={setCustomDist}
          rarityList={rarityList.filter((i) => {
            return i.rarityType === "approvedname";
          })}
        />
      );
    } else if (artOptions[stepState].widget === "distribution") {
      return (
        <Distribution
          setUserSelection={setUserSelection}
          distribution={presetDistribution}
          sliders={sliders}
          pieData={pieData}
          setPieData={setPieData}
          preset={preset}
          setPreset={setPreset}
          showPreset={showPreset}
          setShowPreset={setShowPreset}
          setDefaultSlider={setDefaultSlider}
          title={title}
        />
      );
    } else if (artOptions[stepState].widget === "final") {
      return (
        <FinalCheck
          selectedItems={selectedItems}
          setUserSelection={setUserSelection}
          artOptions={artOptions}
          sliders={sliders}
          preset={preset}
          title={title}
          rarityData={rarityData}
        />
      );
    }
  };

  const renderStepPreview = () => {
    if (["catalogue", "name", "final"].includes(artOptions[stepState].widget)) {
      return (
        <NftPreview
          loader={loader}
          input={selectedItems}
          previewLink={previewLink}
          pieData={pieData}
          preset={preset}
          widget={artOptions[stepState].widget}
        />
      );
    } else if (["distribution"].includes(artOptions[stepState].widget)) {
      return (
        <PieDist
          pieData={pieData}
          preset={preset}
          sliders={sliders}
          previewLink={previewLink}
          widget={artOptions[stepState].widget}
        />
      );
    }
  };

  const renderContent = () => {
    return (
      <section id="mint" className="page-settings">
        <Spinner spinner={isLoading} />
        {renderErrorPopup()}
        {renderWarnPopup()}
        <h1 className="mint__title title-styles-nocaptial">Mint an Octopus</h1>
        <div className="mint__box">
          <div className="mint__box-wrapper">
            <div className="mint__steps">
              <div className="mint__steps-left">
                {/* <h3 className="mint__step-title">{title}</h3> */}
                {renderStep()}
              </div>
              <div className="mint__steps-right">{renderStepPreview()}</div>
            </div>
            <MintFooter
              nextButton={artOptions[stepState + 1]?.navButton}
              backButton={artOptions[stepState - 1]?.navButton}
              stepTotal={artOptions.length - 1}
              stepState={stepState}
              validateSelection={validateSelection}
              input={selectedItems}
              Previous={prevStep}
              Continue={nextStep}
              MintNft={openWarnModal}
            />
          </div>
        </div>
      </section>
    );
  };

  return <React.Fragment>{renderContent()}</React.Fragment>;
};

export default Mint;
